import type { ListBuilderList } from '../../../types';
import { createQuoteShopStandardColumns } from '../columns';
import {
	QUOTE_SHOP_MOBILE_CARD_CONFIG,
	QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Quote Shop Reorder list configuration
 * Reorder items for the quote shop
 */
export const quoteShopSuggestedList: ListBuilderList = {
	id: 'quote_shop_suggested',
	cacheTTL: 600000,
	name: 'Reorder',
	type: 'default',
	active: true,
	sortOrder: 1,
	columns: createQuoteShopStandardColumns(),
	description: 'Reorder items for the quote shop',
	defaultSortId: 'in_stock_first',
	requiredFields: QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: QUOTE_SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'in_stock',
					label: 'In Stock',
				},
				{
					id: 'reorder',
					label: 'Reorder',
				},
			],
		},
	},
};
